<template>
  <main
    :class="[
      'preview',
      {
        bathroom: configurator.name === 'Bathroom',
        chair: configurator.name === 'Chair',
      },
    ]"
  >
    <template v-if="image.url">
      <img class="base-img" :src="image.url" alt="Base Image" />
    </template>
    <img
      ref="watermark"
      class="watermark"
      :src="mycolourlogo"
      alt="Watermark"
    />
    <iframe id="iframe"></iframe>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { EventBus } from '../../eventBus';
import path from 'path';
import mycolourlogo from '@/assets/mycolour-dark.png';
import { detect } from 'detect-browser';
import 'blueimp-canvas-to-blob';
import {
  generate_base_link,
  generate_social_link,
  preload_image,
  print,
  download,
  generate_pdf_doc,
} from '@/lib/helpers';

export default {
  name: 'Preview',
  data() {
    return {
      canvas: null,
      image: {
        url: '',
        blob: null,
        base64: '',
      },
      browser: detect(),
      mycolourlogo: mycolourlogo,
    };
  },
  computed: {
    ...mapGetters([
      'combination',
      'configurator',
      'has_overlay',
      'active_materials',
      'excluded_overlays',
      'selected_materials',
      'price',
    ]),
    overlay_collection() {
      let overlays = this.active_materials;
      this.excluded_overlays.forEach(ex => {
        overlays = overlays.filter(item => !item.includes(ex));
      });
      return overlays;
    },
    overlay_combination() {
      if (!this.has_overlay) return '';
      let combination = this.active_materials.map(overlay =>
        path.basename(overlay, path.extname(overlay))
      );
      return combination.join('');
    },
    is_print_unavailable() {
      return this.browser && this.browser.name === 'ie';
    },
  },
  mounted: function() {
    this.generate_preview_image();

    EventBus.$on('download', this.handle_download);
    EventBus.$on('print', this.scaffold_print);
    EventBus.$on('social', this.handle_social);
    window.scrollTo(0, document.body.scrollHeight);
  },
  methods: {
    generate_preview_image() {
      this.generate_canvas().then(() => {
        this.image.base64 = this.canvas.toDataURL('image/jpeg');
        this.canvas.toBlob(blob => {
          this.image.url = URL.createObjectURL(blob);
          this.image.blob = blob;
        });
      });
    },
    generate_canvas(watermark = false) {
      let preloads = [];

      const { name, style } = this.configurator;
      preloads.push(
        preload_image(generate_base_link(name, style, this.combination))
      );
      const overlays_length = this.overlay_collection.length;

      if (this.has_overlay) {
        for (let i = 0; i < overlays_length; i++) {
          preloads.push(preload_image(this.overlay_collection[i]));
        }
      }

      return Promise.all(preloads).then(response => {
        this.canvas = document.createElement('canvas');
        const ctx = this.canvas.getContext('2d');

        this.canvas.width = 1920;
        this.canvas.height = 1080;

        for (let i = 0; i < response.length; i++) {
          ctx.drawImage(response[i], 0, 0);
        }

        if (watermark) {
          this.$refs.watermark.width = 125;
          this.$refs.watermark.height = 35;

          ctx.drawImage(this.$refs.watermark, 1425, 975);
        }
      });
    },
    handle_download() {
      this.generate_canvas(true).then(() => {
        this.canvas.toBlob(blob => download(blob));
      });
    },
    handle_social() {
      const url = generate_social_link(
        this.$router.currentRoute.name,
        this.$router.currentRoute.params.type,
        this.combination,
        this.overlay_combination
      );
      this.$store.dispatch('set_social_url', url);
    },
    scaffold_print() {
      if (this.is_print_unavailable) {
        alert(
          'IE is not supported for printing. Please use Chrome, Mozilla, or Edge.'
        );
        return false;
      }

      const main_image = this.image.base64;
      generate_pdf_doc(
        main_image,
        this.selected_materials,
        this.configurator.name,
        this.price
      ).then(doc => print(doc));
    },
  },
  watch: {
    combination: 'generate_preview_image',
    overlay_combination: 'generate_preview_image',
  },
};
</script>
